var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"concave-radius-box"},[_c('div',{class:['concave-radius top-left position-right', `concave-radius-${_vm.theme}`],style:(_vm.styles)}),_c('div',{class:['concave-radius top-right position-left', `concave-radius-${_vm.theme}`],style:(_vm.styles)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }